<template>
    <div class="t-reviews-list-course">
        <div class="t-reviews-list-course__items">
            <cmp-reviews v-for="(item, index) in reviews.items" :key="'reviews_' + index" :data="item"></cmp-reviews>
        </div>
        <cmp-pagination class="t-reviews-list-course_comments" v-if="reviews._meta.pageCount > 1"
                        :pages="reviews._meta.pageCount"></cmp-pagination>
    </div>
</template>

<script>
    import {store} from '../../store/index'

    import {mapActions, mapGetters} from 'vuex'

    import Reviews from '../Reviews.vue'

    import Pagination from '../Pagination.vue'

    export default {
        components: {
            'cmp-reviews': Reviews,
            'cmp-pagination': Pagination
        },
        computed: {
            ...mapGetters('coursesList', ['reviews', 'course'])
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            Load() {
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            }
        },
        beforeRouteLeave(to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteEnter(to, from, next) {
            let count = 0;
            store.dispatch('staticText/LoadReviewText').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadReviews', {id: to.params.id}).then(() => {
                count++;
                RunNext();
            });
            let RunNext = () => {
                if (count > 1)
                    next(vm => vm.Load())
            }
        }
    }
</script>

<style lang="sass">
    .t-reviews-list-course
        &__items
            display: flex
            align-items: stretch
            justify-content: flex-start
            flex-wrap: wrap
            margin: 30px -64px 0 0
            .t-review
                width: 305px
        .t-reviews-list-course_comments
            margin: 24px auto -56px
            position: relative
            top: 32px
            justify-content: center
        @media(max-width: 769px)
            margin-top: 24px

            &__items
                margin: 16px
                .t-review
                    width: calc(50% - 8px)
                    margin: 0 0 24px
                    margin-right: 16px
                    &:nth-child(2n)
                        margin-right: 0

        @media(max-width: 500px)
            margin-top: 24px
            &__items
                margin: 0
                .t-review
                    width: 100%
                    margin: 0 0 24px
</style>


// WEBPACK FOOTER //
// src/vue_components/Courses/ReviewList.vue